"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getArrowStyle = getArrowStyle;
exports.getBodyStyle = getBodyStyle;
exports.getInnerStyle = getInnerStyle;

var _utils = require("baseui/popover/utils");

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBodyMargin(placement) {
  const [position] = (0, _utils.splitPlacement)(placement);
  const opposite = (0, _utils.getOppositePosition)(position);

  if (!opposite) {
    return {};
  }

  const property = `margin${(0, _capitalize.default)(opposite)}`;
  return {
    [property]: '1rem'
  };
}

function getBodyStyle(zIndex, {
  $placement: placement,
  $theme: theme
}) {
  const style = {
    borderRadius: theme.borders.radius200,
    backgroundColor: theme.colors.white,
    ...getBodyMargin(placement)
  };

  if (!(0, _isNil.default)(zIndex)) {
    style.zIndex = zIndex;
  }

  return style;
}

function getInnerStyle({
  $theme: theme
}) {
  return {
    backgroundColor: theme.colors.white,
    padding: '1.5rem'
  };
}

function getArrowStyle({
  $theme: theme
}) {
  return {
    backgroundColor: theme.colors.white
  };
}